import { mapObject } from '@client/toolkit';
import { Route, Routes } from 'react-router-dom';
import { UserCreateRoute } from './user-create';
import { UserListRoute } from './user-list';
import { UserRoute } from './user/user.route';

export const UsersPaths = {
  Users: '/users',
  UserCreate: '/users/create',
  User: '/users/details/:id',
};

const RouterPaths = mapObject(UsersPaths, (val: string) => val.replace(UsersPaths.Users, ''));

export const UsersRouter = () => (
  <Routes>
    <Route path="/" element={<UserListRoute />}>
      <Route path={RouterPaths.UserCreate} element={<UserCreateRoute />} />
    </Route>
    <Route path={RouterPaths.User} element={<UserRoute />} />
  </Routes>
);
